import { useRef, useState } from "react";
import { css } from "@emotion/react";

import { ICONS } from "@/modules/ui-elements/Icon";
import DropDownList from './DropDownList/index';
import { useSelector } from "react-redux";

type IDropSelectOptions = {
  title: String,
  selectedItem: any,
  position: object;
}

const DropSelect = ({ items, dropDownTitle='', onItemClick }) => {
  if (!items) return <></>

  const [selectedItem, setSelectedItem] = useState(items[0]);
  const strapiData:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.StudioBackgroundText?.StudioBackgroundText);
  const strapiData2:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.InfographicsPanel?.InfographicsPanel);

  interface IDropSelectRef {
    open: (options: IDropSelectOptions)=>void,
    close: ()=>void,
    selectedItem: typeof items[0]
  }

  const dropSelectRef = useRef<IDropSelectRef>({
    open: (options: IDropSelectOptions) => {},
    close: () => {},
    selectedItem: selectedItem,
  });

  const openBtnRef = useRef<HTMLDivElement>();

  const dropDownListOpenHandler = (e) => {
    dropSelectRef.current.open({
      title: dropDownTitle,
      selectedItem,
      position: {
        top: e.clientY-openBtnRef.current.getBoundingClientRect().top,
        left: e.clientX-openBtnRef.current.getBoundingClientRect().left,
        dropDownPositionWrtVpt: [openBtnRef.current.getBoundingClientRect().top, openBtnRef.current.getBoundingClientRect().left]
      }
    });
  };

  const onUpdateSelectedItemHandler = (item) => {
    dropSelectRef.current.selectedItem = item;
    setSelectedItem(item);
  }

  const onCreateClick = () => {
    onItemClick(selectedItem);
  }
  
  return (
    <div css={styles.dropSelectContainer}>
      <div css={styles.title}>{selectedItem?.title}</div>
      
      <div css={styles.imageBtnContainer}>
        <div css={styles.imageContainer}>
          <img src={selectedItem?.image} css={styles.image} />
        </div>
        <div css={styles.viewAllBtn} ref={openBtnRef} onClick={dropDownListOpenHandler}>
          <span>{strapiData?.ViewAllText || "View All"}</span>
          <img src={ICONS.chevronDownDark} height={15} width={15} />
          <DropDownList ref={dropSelectRef} items={items} onUpdateSelectedItemHandler={onUpdateSelectedItemHandler} />
        </div>
      </div>
      
      <div css={styles.submitBtn} className={`user-selection-disable`} onClick={onCreateClick}>
        <span>{strapiData2?.CreateText || "Create"}</span>
        <img src={ICONS.rightArrowVector} style={{ color: '#FFFFFF !important' }} alt="" height={11} />
      </div>

    </div>
  )
};

export default DropSelect;

const styles = {
  dropSelectContainer: css`
    width: 456px;
    border-radius: 8px;
    border: 1px solid #DEDEDE;
    padding: 20px 18px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  `,
  title: css`
    font-size: 14px;
    font-weight: 400;
    line-height: 23.8px;
    letter-spacing: 0.01em;
  `,
  imageBtnContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  imageContainer: css`
    // width: 64px;
    height: 48px;
    border-radius: 4px;
    border: 0.5px solid #DDE8FE;
    display: flex;
    justify-content: center;
  `,
  image: css`
    // width: 32px;
    object-fit: contain;
  `,
  viewAllBtn: css`
    border-radius: 4px;
    border: 1px solid #DEDEDE;
    padding: 10px 8px;
    cursor: pointer;
    font-size: 12px;
    letter-spacing: -0.1px;
    font-weight: 500;
    display: flex;
    gap: 8px;
    position: relative;
    justify-content: space-between;
    align-items: center;
    &:hover {
      border: 1px solid #262626;
      transition: all 0.3s;
    }
  `,
  submitBtn: css`
    width: 424px;
    height: 48px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    background: #F9F9F9;
    border: none;
    font-size: 14.3px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transition: all 0.3s;
      background: #262626;
      color: #FFFFFF;
    }
    &:hover img {
      transition: all 0.3s;
      filter: brightness(0) saturate(100%) invert(100%);
    }
  `
}